const totalScreenWidth = screen.availWidth;
export const subscriptionReportsColumns = {
  allUsersColumns : [
    { name: 'prop_num', title: 'Prop' },
    { name: 'user_name', title: 'UserName' },
    { name: 'pin', title: 'PIN' },
    { name: 'property_name', title: 'Property' },
    { name: 'last_updated', title: 'Last Up', dataType: "date" },
    { name: 'online_expires', title: 'Expire', dataType: "date"},
    { name: 'update_type', title: 'Update' },
    { name: 'sub_account', title: 'Sub Acct?' },
  ],

  archivedColumns : [
    { name: 'prop_num', title: 'Prop' },
    { name: 'user_name', title: 'UserName' },
    { name: 'pin', title: 'PIN' },
    { name: 'property_name', title: 'Property' },
    { name: 'last_updated', title: 'Last up' },
    { name: 'online_expires', title: 'Expire' },
    { name: 'update_type', title: 'Update' },
    { name: 'sub_account', title: 'Sub Acct?' },
  ],

  allUsersNoRRColumns: [
    { name: 'prop_num', title: 'Prop' },
    { name: 'user_name', title: 'UserName' },
    { name: 'pin', title: 'PIN' },
    { name: 'property_name', title: 'Property' },
    { name: 'last_updated', title: 'Last Up' },
    { name: 'online_expires', title: 'Expire' },
    { name: 'total_fee', title: 'Total Fees' },
    { name: 'template', title: 'Is 4.1?' },
    { name: 'state', title: 'State' }
  ],

  allSubscriptionsColumns: [
    { name: 'prop_num', title: 'Prop #' },
    { name: 'property_name', title: 'Property' },
    { name: 'last_updated', title: 'Last Up' },
    { name: 'online_expires', title: 'Expiration' },
    { name: 'total_fee', title: 'Total Fees' },
    { name: 'online_fee', title: 'Foundation' },
    { name: 'warranty_fee', title: 'Warranty' },
    { name: 'web_news_fee', title: 'TSLive' },
    { name: 'other_fee', title: 'Other' },
    { name: 'other_fee_desc', title: 'Other Fee Desc' },
    { name: 'dsi_notes', title: 'Internal Notes' },
    { name: 'template', title: 'Is 4.1?' },
  ],

  subscriptionsByDateColumns: [
    { name: 'prop_num', title: 'Prop' },
    { name: 'property_name', title: 'Property' },
    { name: 'last_updated', title: 'Last Up' },
    { name: 'online_expires', title: 'Expiration' },
    { name: 'total_fee', title: 'Total Fees' },
    { name: 'online_fee', title: 'Content Mgmt' },
    { name: 'warranty_fee', title: 'Warranty' },
    { name: 'web_news_fee', title: 'TSLive' },
    { name: 'other_fee', title: 'Other' },
    { name: 'other_fee_desc', title: 'Other Fee Desc' },
    { name: 'dsi_notes', title: 'Internal Notes' },
    { name: 'template', title: 'Is 4.1' },
  ],

  expiredUsersColumns: [
    { name: 'prop_num', title: 'Prop #' },
    { name: 'property_name', title: 'Property' },
    { name: 'last_updated', title: 'Last Up' },
    { name: 'online_expires', title: 'Expire' },
    { name: 'total_fee', title: 'Total Fees' },
    { name: 'online_fee', title: 'Foundation' },
    { name: 'warranty_fee', title: 'Hardware' },
    { name: 'web_news_fee', title: 'TSLive' },
    { name: 'other_fee', title: 'Other' },
    { name: 'other_fee_desc', title: 'Other Fee Desc' },
    { name: 'state', title: 'State' },
    { name: 'dsi_notes', title: 'Internal Notes' },
    { name: 'updating_content', title: 'Contact' },
    { name: 'updating_email', title: 'Email' },
    { name: 'billing_email', title: 'Billing Email' },
  ],

  expiredIn30DaysColumn: [
    { name: 'prop_num', title: 'Prop #' },
    { name: 'property_name', title: 'Property' },
    { name: 'last_updated', title: 'Last Up' },
    { name: 'online_expires', title: 'Expiration' },
    { name: 'total_fee', title: 'Total Fees' },
    { name: 'online_fee', title: 'Foundation' },
    { name: 'warranty_fee', title: 'Warranty' },
    { name: 'web_news_fee', title: 'TSLive' },
    { name: 'other_fee', title: 'Other' },
    { name: 'other_fee_desc', title: 'Other Fee Desc' },
    { name: 'state', title: 'State' },
    { name: 'dsi_notes', title: 'Internal Notes' },
    { name: 'template', title: 'Is 4.1' },
  ],

  expiredIn120DaysColumn: [
    { name: 'prop_num', title: 'Prop #' },
    { name: 'property_name', title: 'Property' },
    { name: 'last_updated', title: 'Last Up' },
    { name: 'online_expires', title: 'Expiration' },
    { name: 'total_fee', title: 'Total Fees' },
    { name: 'online_fee', title: 'Foundation' },
    { name: 'warranty_fee', title: 'Warranty' },
    { name: 'web_news_fee', title: 'TSLive' },
    { name: 'other_fee', title: 'Other' },
    { name: 'other_fee_desc', title: 'Other Fee Desc' },
    { name: 'dsi_notes', title: 'Internal Notes' },
    { name: 'template', title: 'Is 4.1?' },
    { name: 'updating_content', title: 'Contact' },
  ],

  allTSLiveReportsColumns: [
    { name: 'prop_num', title: 'Prop #' },
    { name: 'property_name', title: 'Property' },
    { name: 'web_news_fee', title: 'TSLive' },
    { name: 'dsi_notes', title: 'Internal Notes' },
    { name: 'template', title: 'Is 4.1?' },
    { name: 'online_expires', title: 'Expiration' },
  ],

  specialBillingReportsColumns: [
    { name: 'prop_num', title: 'PropNum' },
    { name: 'user_name', title: 'UserName' },
    { name: 'pin', title: 'PIN' },
    { name: 'property_name', title: 'Property' },
    { name: 'last_updated', title: 'Last Up' },
    { name: 'online_expires', title: 'Expire' },
    { name: 'total_fee', title: 'Total Fees' },
    { name: 'online_fee', title: 'Foundation' },
    { name: 'warranty_fee', title: 'Warranty' },
    { name: 'web_news_fee', title: 'TSLive' },
    { name: 'other_fee', title: 'Other' },
    { name: 'other_fee_desc', title: 'Other Fee Desc' },
    { name: 'dsi_notes', title: 'Internal Notes' }
  ],

  irvineAccountsColumns: [
    { name: 'prop_num', title: 'Prop' },
    { name: 'user_name', title: 'User Name' },
    { name: 'pin', title: 'PIN' },
    { name: 'property_name', title: 'Property' },
    { name: 'last_updated', title: 'Last Up' },
    { name: 'online_expires', title: 'Expire' },
    { name: 'total_fee', title: 'Total Fees' },
    { name: 'dsi_notes', title: 'Notes' },
    { name: 'template', title: 'Is 4.1?' },
    { name: 'state', title: 'State' }
  ],

  redyRefAccountsColumns: [
    { name: 'prop_num', title: 'PropNum' },
    { name: 'user_name', title: 'UserName' },
    { name: 'pin', title: 'PIN' },
    { name: 'property_name', title: 'Property' },
    { name: 'last_updated', title: 'Last Update' },
    { name: 'online_expires', title: 'Expiration' },
    { name: 'total_fee', title: 'Fee Total' },
    { name: 'update_type', title: 'Update?' }
  ],

  canceledUsersReportsColumns: [
    { name: 'prop_num', title: 'Prop Number' },
    { name: 'cancel_date', title: 'Cancel Date' },
    { name: 'online_expires', title: 'Expiration Date' },
    { name: 'archive', title: 'Archived?' },
    { name: 'cancel_reason', title: 'Reason' },
    { name: 'cancel_notes', title: 'Notes' },
    { name: 'state', title: 'State' },
  ],

  tableDetailColumnExtensions: [
    { columnName: 'prop_num', width: totalScreenWidth / 30 },
    { columnName: 'user_name', width: totalScreenWidth / 15 },
    { columnName: 'pin', width: totalScreenWidth / 30 },
    { columnName: 'property_name', width: totalScreenWidth / 8 },
    { columnName: 'last_updated', width: totalScreenWidth / 30 },
    { columnName: 'online_expires', width: totalScreenWidth / 30 },
    { columnName: 'update_type', width: totalScreenWidth / 30 },
    { columnName: 'sub_account', width: totalScreenWidth / 30 },
    { columnName: 'template', width: totalScreenWidth / 30 },
    { columnName: 'state', width: totalScreenWidth / 30 },
    { columnName: 'total_fee', width: totalScreenWidth / 30 },
    { columnName: 'web_news_fee', width: totalScreenWidth / 30 },
    { columnName: 'dsi_notes', width: totalScreenWidth / 10 },
    { columnName: 'archive', width: totalScreenWidth / 30 },
    { columnName: 'online_fee', width: totalScreenWidth / 30 },
    { columnName: 'warranty_fee', width: totalScreenWidth / 30 },
    { columnName: 'other_fee', width: totalScreenWidth / 30 },
    { columnName: 'other_fee_desc', width: totalScreenWidth / 30 },
    { columnName: 'updating_content', width: totalScreenWidth / 30 },
    { columnName: 'updating_email', width: totalScreenWidth / 30 },
    { columnName: 'billing_email', width: totalScreenWidth / 30 },
    { columnName: 'cancel_date', width: totalScreenWidth / 30 },
    { columnName: 'cancel_reason', width: totalScreenWidth / 15 },
    { columnName: 'cancel_notes', width: totalScreenWidth / 10 },
  ],     
  
  tableAlignColumnExtensions: [
    { columnName: 'prop_num', align: 'center' },
    { columnName: 'user_name', align: 'center' },
    { columnName: 'pin', align: 'center' },
    { columnName: 'property_name', align: 'center' },
    { columnName: 'last_updated', align: 'center' },
    { columnName: 'online_expires', align: 'center' },
    { columnName: 'update_type', align: 'center' },
    { columnName: 'sub_account', align: 'center' },
    { columnName: 'template', align: 'center' },
    { columnName: 'state', align: 'center' },
    { columnName: 'total_fee', align: 'center' },
    { columnName: 'web_news_fee', align: 'center' },
    { columnName: 'dsi_notes', align: 'center' },
    { columnName: 'archive', align: 'center' },
    { columnName: 'online_fee', align: 'center' },
    { columnName: 'warranty_fee', align: 'center' },
    { columnName: 'other_fee', align: 'center' },
    { columnName: 'other_fee_desc', align: 'center' },
    { columnName: 'updating_content', align: 'center' },
    { columnName: 'updating_email', align: 'center' },
    { columnName: 'billing_email', align: 'center' },
    { columnName: 'cancel_date', align: 'center' },
    { columnName: 'cancel_reason', align: 'center' },
    { columnName: 'cancel_notes', align: 'center' },
  ],    
  
  subscriptionReportList: [
    { report: 'allUsers', reportLabel: 'All Users'},
    { report: 'archived', reportLabel:  'Archive'},
    { report: 'allUserNoRR', reportLabel:  'All Users - No RR'},
    { report: 'allSubscriptions', reportLabel:  'All Subscriptions'},
    { report: 'subscriptionsByDate', reportLabel: 'Subscriptions by date'},
    { report: 'expiredUsers', reportLabel:  'Expired users'},
    { report: 'expiredIn30days', reportLabel:  'Expired In 30 Days'},
    { report: 'expiredIn120days', reportLabel:  'Expired In 120 Days'},
    { report: 'allTSLiveReport', reportLabel:  'All TSLive Report'},
    { report: 'specialBillingReports', reportLabel:  'Special Billing report'},
    { report: 'listOfIrvineAccounts', reportLabel:  'List of Irvine Accounts'},
    { report: 'listOfRedyRefAccounts', reportLabel:  'List of RedyRef Accounts'},
    { report: 'cancelledUsersReport', reportLabel:  'Cancelled users report'}
  ]

};


// WEBPACK FOOTER //
// ./src/components/Subscription/subscriptionReportsColumns.ts